// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__OyDIf","dadosUsuario":"OptionSelect_dadosUsuario__g9w3I","focado":"OptionSelect_focado__FzeVb"};